import { action, observable, computed } from 'mobx';
import JobModel from './JobModel';
import JobLogMessageModel from './JobLogMessageModel';

class JobStore {
    @observable fetching = false;
    @observable fetchingJob = false;
    @observable fetchingLogs = false;
    @observable fetched = false;
    @observable fetchedJob = false;
    @observable fetchedLogs = false;
    @observable jobs = [];
    @observable job = null;
    @observable logs = [];

    auth = null;

    constructor(auth) {
        // Set auth
        this.auth = auth;
    }

    @computed
    get runningJobsCount() {
        return this.jobs.reduce(
            (sum, job) => sum + (job.status === 'running' ? 1 : 0),
            0,
        );
    }

    @action.bound
    fetch() {
        this.fetching = true;
        this.auth.apiGet('/api/jobs')
            .then(action('update state after fetching data', (data) => {
                const newJobsList = data.map(item => JobModel.fromJS(item));
                this.jobs.replace(newJobsList);
                this.fetched = true;
                this.fetching = false;
            }));
    }

    @action.bound
    fetchJob(id) {
        this.fetching = true;
        this.auth.apiGet(`/api/jobs/${id}`)
            .then(action('update state after fetching data', (data) => {
                const newJob = JobModel.fromJS(data);
                this.job = newJob;
                this.fetchedJob = true;
                this.fetchingJob = false;
            }));
    }

    @action.bound
    fetchJobLogs(id) {
        this.fetching = true;
        this.auth.apiGet(`/api/jobs/${id}/logs`)
            .then(action('update state after fetching data', (data) => {
                const newLogsList = data.map(item => JobLogMessageModel.fromJS(item));
                this.logs.replace(newLogsList);
                this.fetchedLogs = true;
                this.fetchingLogs = false;
            }));
    }

    // syncUpdate() {
    //     // this.auth.socket.syncUpdates('job', this.jobs);
    // }
    //
    // unsyncUpdates() {
    //     // this.auth.socket.unsyncUpdates('job');
    // }

    // subscribeServerToStore() {
    //     // console.log('--> SAVING TO SERVER ??');
    //     // this.jobs.push(new JobModel('id', 'type', 'name', 'instance', 'running', 'normal', 90));
    //     reaction(
    //         () => this.toJS(),
    //         // jobs => console.log('SAVING TO SERVER ??'),
    //         // this.jobs.push(new JobModel('id', 'type', 'name', 'instance', 'running', 'normal', 90)),
    //         //     fetch('/api/jobs', {
    //         //     method: 'post',
    //         //     body: JSON.stringify({ jobs }),
    //         //     headers: new Headers({ 'Content-Type': 'application/json' })
    //         // })
    //     );
    // }
    //
    // subscribeLocalstorageToStore() {
    //     reaction(
    //         () => this.toJS(),
    //         todos => window.localStorage.setItem('mobx-react-todomvc-todos', JSON.stringify({ todos })),
    //     );
    // }

    // addJob (title) {
    //     this.jobs.push(new JobModel(this, Utils.uuid(), title, false));
    // }

    toJS() {
        return this.jobs.map(job => job.toJS());
    }

    static fromJS(auth, array) {
        const jobStore = new JobStore(auth);
        jobStore.jobs = array.map(item => JobModel.fromJS(item));
        return jobStore;
    }
}

export default JobStore;
